import script from "./TransactionDetailAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionDetailAccordion.vue?vue&type=script&setup=true&lang=js"

import "./TransactionDetailAccordion.vue?vue&type=style&index=0&id=d840b22e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d840b22e"]])

export default __exports__